import Api from '@/modules/core/api/api.ts';
import type { SegmentDto } from '@/modules/counterparty/dto/segment.dto.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import { SegmentAdapter } from '@/modules/counterparty/adapters/segment.adapter.ts';
import { SegmentEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';
import { requirePositiveId } from '@/modules/common/utils/number.util.ts';

export class SegmentApi {
  static async getList(signal: AbortSignal) {
    const response: ItemsDto<SegmentDto> = await Api.post(
      SegmentEndPoint.GetList,
      RequestUtil.orderBy('Название', Direction.Asc),
      signal
    );
    return SegmentAdapter.mapList(response);
  }

  static async add(name: string, note?: string, signal?: AbortSignal) {
    const response = await Api.post(SegmentEndPoint.Add, { segment_name: name, note: note || undefined }, signal);
    return requirePositiveId(response.segment_id, 'The segment id is not defined.');
  }

  static async edit(id: number, name: string, note = '', signal?: AbortSignal) {
    const response = await Api.post(SegmentEndPoint.Edit, { segment_id: id, segment_name: name, note }, signal);
    return requirePositiveId(response.segment_id, 'The segment id is not defined.');
  }

  static async delete(id: number, signal?: AbortSignal) {
    await Api.post(SegmentEndPoint.Delete, { segment_id: id }, signal);
  }
}
